import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
	colors,
} from '@mui/material';

import ModalDialog from '../../../../../../components/ModalDialog/ModalDialog.js';
import AddEditUserForm from './components/AddEditUserForm/AddEditUserForm.js';
import { GetRoles, GetOperators, CreateUser, GetUser, EditUser } from '../../../../actions/UsersActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const AddEditUserDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const roles = useSelector((state) => state.usersReducer.roles);
	const operators = useSelector((state) => state.usersReducer.operators);
	const operatorProjects = useSelector((state) => state.usersReducer.operatorProjects);
	const formState = useSelector((state) => state.usersReducer.formState);
	const openAddEditUserDialogId = useSelector((state) => state.usersReducer.openAddEditUserDialogId);
	const title = openAddEditUserDialogId ? 'Edit user' : 'Add user';

	const _onConfirmClick = () => {
		if (formState.isValid) {
			if (openAddEditUserDialogId) {
				dispatch(EditUser(formState.values, rest.user.role));
			} else {
				dispatch(CreateUser(formState.values, rest.user.role));
			}
		}
	};

	const getData = useCallback(() => {
		dispatch(GetRoles(rest.user.role));
		dispatch(GetOperators());
	}, []);

	useEffect(() => {
		getData();
		if (openAddEditUserDialogId) {
			dispatch(GetUser(openAddEditUserDialogId));
		}
	}, [openAddEditUserDialogId]);

	return (
		<ModalDialog
			maxWidth="md"
			onClose={onClose}
			open={open}
			title={title}
			confirmLabel="Save"
			onConfirmClicked={_onConfirmClick}
		>
			<br />
			<AddEditUserForm isEdit={openAddEditUserDialogId} roles={roles} operators={operators} projects={operatorProjects} />
		</ModalDialog>
	);
};

AddEditUserDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default AddEditUserDialog;
